import React, { useState } from "react";
import { t } from "i18next";
import { useSelector, useDispatch } from "react-redux";
// import { useParams } from "react-router-dom";

import WithMap from "components/Hoc/WithMap";
// import PageHeader from "components/PageHeader";
// import FixedFooter from "components/FixedFooter";

import { ErrorModal, CustomModal } from "components";
import WithLoading from "components/Hoc/WithLoading";
import { useMapContext } from "contexts/googleMap";

// import { useCustomHistory } from "hooks";
import usePreFillLocalStorageAddress from "../../hooks/usePreFillLocalStorageAddress";

import C from "Constants";
import * as AC from "store/actions";
import DeliveryAreaModal from "components/Modals/DeliveryAreaModal";
import DeliveryStoreList from "components/Modals/DeliveryStoreList";
import PickupStoresModal from "components/Modals/PickupStoresModal";
import { DeliveryAddressAction } from "store/actions";

import { useDeliveryAddressContext } from "contexts/userAddressess";
import useGetBrandAres from "service-hooks/useGetBrandAres";
import useFetchBrandStoresByLatLng from "service-hooks/useFetchBrandStoresByLatLng";
import { PageHeaderV2 } from "components/PageHeader";
import useDelivertPickupFn from "features/hooks/useDelivertPickupFn";
import { TranslationText } from "components/TextTranslationContainer";
import { CustomButton } from "components/Button";
import { NotPersistAction } from "store/actions";

//TODO: requires cleanup

function AddGeoLocationOnHomePage() {
  const dispatch = useDispatch();
  const { goToStorePage, goToHomePage, goToSettings, goToLogin, location, storeUrl, homeUrl} =
    useDelivertPickupFn();
  const fetchBrandStoresByLatLng = useFetchBrandStoresByLatLng();
  const [mapref, setMapRef] = useState(null);
  const { deliveryAreas } = useSelector((state) => state.brand);
  const { error, errorModaL } = useSelector((rstate) => rstate.errorSlice);
  const { orderType } = useSelector((state) => state.AppReducer);
  const { zoom } = useSelector((state) => state.DeliveryAddressReducer);

  const { selectedStore, outletBasedSelectedStoreArea } = useSelector(
    (state) => state.store
  );

  const { googlemapState } = useMapContext();
  usePreFillLocalStorageAddress();

  const updateTemporaryLocation = () => {
    dispatch(
      DeliveryAddressAction.setTempMapAddress(googlemapState?.mapAddress)
    );
    dispatch(DeliveryAddressAction.setTempZoom(googlemapState?.zoom || 16));
    dispatch(
      DeliveryAddressAction.setTempUserLocation(
        googlemapState?.userLocation?.coordinates
      )
    );
    dispatch(DeliveryAddressAction.setisGeoLocationAdded(true));
  };

  const { fetchBrandAreas } = useGetBrandAres();

  const goBack = () => {
    if (
     ( (orderType?.serviceType === C.SERVICE_TYPE.DELIVERY && outletBasedSelectedStoreArea) ||
      (orderType?.serviceType === C.SERVICE_TYPE.PICKUP)) && selectedStore
    )
      goToStorePage(location.state);
    else goToHomePage(location.state);
  };

  const getAreasLength = () => deliveryAreas?.deliveryAreas?.length || 0;
  const { setAddressState, userAddressState } = useDeliveryAddressContext();

  return (
    <WithLoading>
      <div className="relative w-screen h-app-height bg-white store-page-popup">
        <PageHeaderV2
          pageTitle={"Set Delivery Location"}
          onGoBack={goBack}
          authClick={goToLogin}
          userClick={goToSettings}
          containerStyleProps={{
            style: {
              position: "relative",
            },
          }}
        />
        <div
          className="p-4 flex flex-col gap-2 justify-between"
          style={{ height: "calc(100% - 75px)" }}
        >
          <div>
            <TranslationText
              text="Where should we deliver"
              as="h1"
              className="text-24x font-bold text-shadow-forge-900"
            />
            <TranslationText text="We need your location to check if this restaurant delivers to you." />
          </div>
          <WithMap
            class="flex-1"
            width="100%"
            height={"calc(100% - 75px)"}
            showInput={true}
            zoomChanging={true}
            zoom={zoom}
            setMapRef={setMapRef}
            mapref={mapref}
            googlemapState={{
              userLocation: {
                lat: googlemapState?.userLocation?.coordinates?.lat,
                lng: googlemapState?.userLocation?.coordinates?.lng,
              },
              zoom: googlemapState?.zoom,
              mapAddress: googlemapState?.mapAddress,
            }}
            zoomerror={userAddressState?.zoomErrorModal?.message?.msg}
            isZoomModalOpen={userAddressState?.zoomErrorModal?.open}
            setZoomErrorModal={() =>
              setAddressState("zoomErrorModal", { open: false, message: "" })
            }
          />
          {getAreasLength() > 0 && (
            <div className="font-bold flex mb-1 justify-center gap-2 items-center w-full bg-white h-12">
              <h2 className="mx-2">{t("Having trouble searching")}</h2>
              <CustomButton
                onClick={fetchBrandAreas}
                outline={true}
                className="flex group items-center gap-2 w-fit"
                style={{
                  padding: "5px 10px",
                }}
              >
                <TranslationText text="Select location" />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3 w-3 group-hover:text-white"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 3a1 1 0 0 0-.707.293l-6 6a1 1 0 0 0 1.414 1.414L10 5.414l5.293 5.293a1 1 0 0 0 1.414-1.414l-6-6A1 1 0 0 0 10 3z"
                    clipRule="evenodd"
                  />
                </svg>
              </CustomButton>
            </div>
          )}
          <CustomButton
            onClick={() => {
              dispatch(
                NotPersistAction.setHistoryState({
                  state: location.state,
                  storeUrl,
                  homeUrl,
                })
              );
              fetchBrandStoresByLatLng();
              if(location.state?.isNotOpenAreaModal) {
                updateTemporaryLocation()
                goToHomePage(location.state);
              }
            }}
          >
            <TranslationText text="Confirm Location" />
          </CustomButton>
        </div>
        {location.state?.isNotOpenAreaModal ? null : ( 
        
          <>
            <DeliveryAreaModal />
            <DeliveryStoreList
              updateTemporaryLocation={updateTemporaryLocation}
            />
            <PickupStoresModal />
          </>
         )}
        <CustomModal
          open={errorModaL}
          reduxAction={AC.ErrorAction.setErrorModal(false)}
          bodyclasses="flex"
          overlayClasses="fixed h-screen w-screen top-0 bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-40"
        >
          <ErrorModal
            reduxAction={AC.ErrorAction.setErrorModal(false)}
            message={error}
          />
        </CustomModal>
      </div>
    </WithLoading>
  );
}

export default AddGeoLocationOnHomePage;
